import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "home-land-tab" }
const _hoisted_2 = {
  key: 0,
  class: "spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "card home-land-card"
}
const _hoisted_4 = { class: "panel-header" }
const _hoisted_5 = { class: "toggle-group" }
const _hoisted_6 = { class: "setup-section" }
const _hoisted_7 = { class: "builder-card" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = {
  key: 1,
  class: "builder-fallback"
}
const _hoisted_10 = { class: "builder-details" }
const _hoisted_11 = {
  class: "input dropdown-input",
  type: "button"
}
const _hoisted_12 = { class: "builder-options" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 1,
  class: "input dropdown-input",
  type: "button",
  disabled: ""
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "documents-section" }
const _hoisted_17 = { class: "section-header" }
const _hoisted_18 = { class: "documents-actions" }
const _hoisted_19 = { class: "documents-count" }
const _hoisted_20 = ["disabled", "accept"]
const _hoisted_21 = {
  key: 0,
  class: "documents-list"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "document-copy" }
const _hoisted_24 = { class: "document-name" }
const _hoisted_25 = {
  key: 0,
  class: "document-date"
}
const _hoisted_26 = { class: "document-actions" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick", "disabled"]
const _hoisted_29 = {
  key: 1,
  class: "empty-documents"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : ($setup.localLot)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "panel-title" }, [
                _createElementVNode("h3", null, "Home & Land Package")
              ], -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", {
                  class: _normalizeClass(["toggle-status", { active: $setup.localLot.isBuildersEnabled }])
                }, _toDisplayString($setup.localLot.isBuildersEnabled ? "Enabled" : "Disabled"), 3),
                _createVNode($setup["ToggleButton"], {
                  modelValue: $setup.localLot.isBuildersEnabled,
                  label: '',
                  additionalClass: 'large',
                  "onUpdate:modelValue": $setup.toggleHomeAndLand
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: _normalizeClass(["builder-preview", { empty: !$setup.selectedBuilder }])
                }, [
                  ($setup.selectedBuilder?.logo)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "builder-logo",
                        src: $setup.selectedBuilder.logo,
                        alt: `${$setup.selectedBuilder.name} logo`
                      }, null, 8, _hoisted_8))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($setup.selectedBuilderInitials), 1))
                ], 2),
                _createElementVNode("div", _hoisted_10, [
                  _cache[1] || (_cache[1] = _createElementVNode("label", { class: "input-label" }, "Builder", -1)),
                  ($setup.localLot.isBuildersEnabled)
                    ? (_openBlock(), _createBlock($setup["DropDown"], {
                        key: 0,
                        class: "builder-dropdown",
                        placement: "left bottom"
                      }, {
                        control: _withCtx(() => [
                          _createElementVNode("button", _hoisted_11, _toDisplayString($setup.selectedBuilder?.name || "Select builder"), 1)
                        ]),
                        dropdown: _withCtx(() => [
                          _createElementVNode("ul", _hoisted_12, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.builders, (builder) => {
                              return (_openBlock(), _createElementBlock("li", {
                                class: "builder-option",
                                key: builder._id,
                                onClick: ($event: any) => ($setup.selectBuilder(builder))
                              }, [
                                _createElementVNode("span", null, _toDisplayString(builder.name), 1)
                              ], 8, _hoisted_13))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock("button", _hoisted_14, "Select builder"))
                ])
              ]),
              _createElementVNode("button", {
                class: "button default primary save-button",
                type: "button",
                onClick: $setup.saveLot,
                disabled: $setup.saving
              }, "Save", 8, _hoisted_15)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[3] || (_cache[3] = _createElementVNode("h4", null, "Builder Documents", -1)),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString($setup.builderDocuments.length) + " uploaded", 1),
                  _createElementVNode("label", {
                    class: _normalizeClass(["button default primary outlined document-upload", { disabled: !$setup.canUploadDocuments }])
                  }, [
                    _cache[2] || (_cache[2] = _createTextVNode("Upload", -1)),
                    _createElementVNode("input", {
                      type: "file",
                      disabled: !$setup.canUploadDocuments || $setup.uploading,
                      accept: $setup.acceptedDocumentTypes,
                      onChange: $setup.uploadDocument
                    }, null, 40, _hoisted_20)
                  ], 2)
                ])
              ]),
              ($setup.builderDocuments.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.builderDocuments, (document, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "document-item",
                        key: document.fileName
                      }, [
                        _createElementVNode("div", {
                          class: "document-main",
                          onClick: ($event: any) => ($setup.openDocument(document))
                        }, [
                          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "document-icon" }, null, -1)),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, _toDisplayString($setup.getDocumentName(document.fileName)), 1),
                            (document.modifiedDate)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString($setup.formatDate(document.modifiedDate)), 1))
                              : _createCommentVNode("", true)
                          ])
                        ], 8, _hoisted_22),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("button", {
                            class: "button default primary outlined document-action",
                            type: "button",
                            onClick: ($event: any) => ($setup.openDocument(document))
                          }, "View", 8, _hoisted_27),
                          _createElementVNode("button", {
                            class: "button default warning outlined document-action",
                            type: "button",
                            onClick: ($event: any) => ($setup.deleteDocument(document.fileName, index)),
                            disabled: $setup.deletingDocumentKey === document.fileName
                          }, "Delete", 8, _hoisted_28)
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_29, [...(_cache[5] || (_cache[5] = [
                    _createElementVNode("div", { class: "empty-icon" }, null, -1),
                    _createElementVNode("span", null, "No builder documents uploaded.", -1)
                  ]))]))
            ])
          ]))
        : _createCommentVNode("", true)
  ]))
}